export enum Role {
  USER = 1,
  ADMIN = 2,
  SUPER_ADMIN = 3,
  CUSTOMER_SERVICE = 4,
  TTB_AGENT = 5,
  TTB_MANAGER = 6,
}
